import styled from 'styled-components';
import ThemeHelper from '../../../themes/theme-helper';

import {
  flexbox,
  flexDirection,
  alignItems,
  justifyContent,
  inlineFlexbox
} from '../../../styles/helpers/flexbox';

export const ModalBody = styled.div((props) => {
  const { palette } = props.theme;

  return `
    ${flexbox()};
    ${flexDirection('column')};
    ${alignItems('center')};

    min-width: 400px;
    min-height: 400px;

    color: ${palette.primary.dark};
  `;
});
export const StudentDetails = styled.div`
  ${justifyContent('center')};
  ${flexDirection('column')};

  margin-bottom: 10px;
  user-select: none;
`;

export const StudentName = styled.div`
  font-size: 21px;
  line-height: 31px;
`;

export const CourseDetails = styled.div`
  ${inlineFlexbox()};
  font-size: 16px;
  line-height: 25px;
  margin: 0 10px;
`;

export const TabContainer = styled.div`
  z-index: 100;
`;

export const TabHeading = styled.div((props) => {
  const { colours, palette } = ThemeHelper.getTheme(props);
  let statusColor = '';
  const { selected } = props;
  statusColor = selected ? palette.primary.text : colours.grey[200];
  return `
    font-size: 16px;
    font-weight: normal;
    background-color: ${statusColor};
    border: 1px solid ${colours.grey[400]};
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    ${props.selected ? 'border-bottom-color: #fff;' : ''}
    cursor: ${props.selected ? 'default' : 'pointer'};
    height: 35px;
    ${inlineFlexbox()};
    ${justifyContent('center')}
    padding: 5px 10px;
    box-sizing: border-box;
    min-width: 125px;

    &:not(:last-child) {
      margin-right: 10px;
    }

    div[class*='svgIconComponent--'] {
      width: auto;
      margin-right: 5px;
      
      path {
        fill: #3C4E5E;
      }
    }
  `;
});

export const TabbedPanel = styled.section`
  width: 100%;
  height: 320px;
`;

export const ResultContainer = styled.div`
  ${flexbox()};
  ${flexDirection('column')};
  ${alignItems('center')};

  width: -webkit-fill-available;
`;

export const LoaderWrapper = styled.div`
  ${inlineFlexbox()};
  ${justifyContent('center')};
  ${alignItems('center')};

  min-height: 450px;
`;



// WEBPACK FOOTER //
// ./components/student-list/student-modal/student-modal.styled.js